<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="row mb-2">
          <div class="col-sm-3 mb-1">
            <router-link to="/project">
            <div class="card h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-7 mt-1">
                  <h5><b>{{total_target.total}}</b></h5>
                  <div class="text-muted mt-1">
                      <h5 class="font-size-14 mb-0 text-secondary">{{ $t('dashboard.total-target.text') }}</h5>
                  </div>
                  </div>
                  <div class="col-sm-5 float-right">
                    <div class="avatar-sm mr-1 float-right">
                    <span class="avatar-title rounded-circle bg-primary text-white font-size-18">
                      <i class="bx bx-target-lock bx-md"></i>
                    </span>
                  </div>
                  </div>
                  <div class="mt-3 col-12">
                      <span class="text-primary">{{ $t('dashboard.last-updated.text') }} {{formatDate(total_target.last_date)}}</span>
                  </div>
                </div>
              </div>
            </div>
            </router-link>
          </div>
          <div class="col-sm-3 mb-1">
            <router-link to="/citizen">
            <div class="card h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-7 mt-1">
                  <h5 class="text-"><b>{{formatPrice(total_citizen)}}</b></h5>
                  <div class="text-muted mt-1">
                      <h5 class="font-size-14 mb-0 text-secondary">{{ $t('dashboard.total-database-citizen.text') }}</h5>
                  </div>
                  </div>
                  <div class="col-sm-5 float-right">
                    <div class="avatar-sm mr-1 float-right">
                    <span class="avatar-title rounded-circle bg-primary text-white font-size-18">
                      <i class="bx bx-pin bx-md"></i>
                    </span>
                  </div>
                  </div>
                  <div class="mt-3 col-12">
                      <span class="text-primary">{{ $t('dashboard.last-updated.text') }} {{formatDate(total_citizen_date)}}</span>
                  </div>
                </div>
              </div>
            </div>
            </router-link>
          </div>
           <div class="col-sm-3 mb-1">
            <router-link to="/">
            <div class="card h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-7 mt-1">
                  <h5><b>{{formatPrice(total_tokopedia)}}</b></h5>
                  <div class="text-muted mt-1">
                    <h3>
                      <h5 class="font-size-14 mb-0 text-secondary">{{ $t('dashboard.total-database-tokopedia.text') }}</h5>
                    </h3>
                  </div>
                  </div>
                  <div class="col-sm-5 float-right">
                    <div class="avatar-sm mr-1 float-right">
                    <span class="avatar-title rounded-circle bg-primary text-white font-size-18">
                      <i class="bx bx-pin bx-md"></i>
                    </span>
                  </div>
                  </div>
                  <div class="mt-3 col-12">
                      <span class="text-primary">{{ $t('dashboard.last-updated.text') }} {{formatDate(total_tokopedia_date)}}</span>
                  </div>
                </div>
              </div>
            </div>
            </router-link>
          </div>
           <div class="col-sm-3 mb-1">
            <div class="card h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-7 mt-1">
                  <h5><b>{{formatPrice(total_facebook)}}</b></h5>
                  <div class="text-muted mt-1">
                    <h3>
                      <h5 class="font-size-14 mb-0 text-secondary">{{ $t('dashboard.total-database-facebook.text') }}</h5>
                    </h3>
                  </div>
                  </div>
                  <div class="col-sm-5 float-right">
                    <div class="avatar-sm mr-1 float-right">
                    <span class="avatar-title rounded-circle bg-primary text-white font-size-18">
                      <i class="bx bx-pin bx-md"></i>
                    </span>
                  </div>
                  </div>
                    <div class="mt-3 col-12">
                      <span class="text-primary">{{ $t('dashboard.last-updated.text') }} {{formatDate(total_facebook_date)}}</span>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
             <div class="col-sm-3 mb-1" v-if="user_type == 'superadmin' || user_type == 'vvip' || user_type == 'admin'">
            <router-link to="/user-management">
            <div class="card h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-7 mt-1">
                  <h5 class="text-"><b>{{total_users.total}}</b></h5>
                  <div class="text-muted mt-1">
                      <h5 class="font-size-14 mb-0 text-secondary">{{ $t('dashboard.total-user.text') }}</h5>
                  </div>
                  </div>
                  <div class="col-sm-5 float-right">
                    <div class="avatar-sm mr-1 float-right">
                    <span class="avatar-title rounded-circle bg-primary text-white font-size-18">
                      <i class="bx bx-user bx-md"></i>
                    </span>
                  </div>
                  </div>
                  <div class=" col-12 mt-3">
                      <span class="text-primary">{{ $t('dashboard.last-updated.text') }} {{formatDate(total_users.last_date)}}</span>
                  </div>
                </div>
              </div>
            </div>
            </router-link>
          </div>
          <div class="col-sm-3 mb-1">
            <router-link to="/twitter">
            <div class="card h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-7 mt-1">
                  <h5 class="text-"><b>{{total_twitter.total}}</b></h5>
                  <div class="text-muted mt-1">
                      <h5 class="font-size-14 mb-0 text-secondary">{{ $t('dashboard.twitter-account.text') }}</h5>
                  </div>
                  </div>
                  <div class="col-sm-5 float-right">
                    <div class="avatar-sm mr-1 float-right">
                    <span class="avatar-title rounded-circle bg-primary text-white font-size-18">
                      <i class="bx bxl-twitter bx-md"></i>
                    </span>
                  </div>
                  </div>
                  <div class="col-12 mt-3">
                      <span class="text-primary">{{ $t('dashboard.last-updated.text') }} {{formatDate(total_twitter.last_date)}}</span>
                  </div>
                </div>
              </div>
            </div>
            </router-link>
          </div>
           <div class="col-sm-3 mb-1">
            <router-link to="/instagram">
            <div class="card h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-7 mt-1">
                  <h5><b>{{total_instagram.total}}</b></h5>
                  <div class="text-muted mt-1">
                      <h5 class="font-size-14 mb-0 text-secondary">{{ $t('dashboard.instagram-account.text') }}</h5>
                  </div>
                  </div>
                  <div class="col-sm-5 float-right">
                    <div class="avatar-sm mr-1 float-right">
                    <span class="avatar-title rounded-circle bg-primary text-white font-size-18">
                      <i class="bx bxl-instagram bx-md"></i>
                    </span>
                  </div>
                  </div>
                  <div class="col-12 mt-3">
                      <span class="text-primary">{{ $t('dashboard.last-updated.text') }} {{formatDate(total_instagram.last_date)}}</span>
                  </div>
                </div>
              </div>
            </div>
            </router-link>
          </div>
           <div class="col-sm-3 mb-1">
            <router-link to="/group-telegram">
            <div class="card h-100">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-7 mt-1">
                  <h5><b>{{total_group}}</b></h5>
                  <div class="text-muted mt-1">
                    <h3>
                      <h5 class="font-size-14 mb-0 text-secondary">{{ $t('dashboard.total-group-telegram.text') }}</h5>
                    </h3>
                  </div>
                  </div>
                  <div class="col-sm-5 float-right">
                    <div class="avatar-sm mr-1 float-right">
                    <span class="avatar-title rounded-circle bg-primary text-white font-size-18">
                      <i class="bx bx-chat bx-md"></i>
                    </span>
                  </div>
                  </div>
                   <div class="col-12 mt-2">
                      <span class="text-primary">{{ $t('dashboard.last-updated.text') }} {{formatDate(total_group_date)}}</span>
                  </div>
                </div>
              </div>
            </div>
            </router-link>
          </div>
        </div>
      
        <!-- end row -->
        <div class="row mb-3">
          <div class="col-sm-8">
            <div class="card h-100">
              <div class="card-body">
                <div class="clearfix">
                  <div class="float-right">
                    <!-- <div class="input-group input-group-sm">
                      <select class="custom-select custom-select-sm">
                        <option selected>Jan</option>
                        <option value="1">Dec</option>
                        <option value="2">Nov</option>
                        <option value="3">Oct</option>
                      </select>
                      <div class="input-group-append">
                        <label class="input-group-text">Month</label>
                      </div>
                    </div> -->
                  </div>
                  <h5 class="card-title mb-4">{{ $t('dashboard.target-profil.text') }}</h5>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <apexchart
                          class="apex-charts"
                          height="340"
                          type="area"
                          dir="ltr"
                          :series="splineAreaChart.series"
                          :options="{
                                      chart: {
                                        id: 'pageview-chart',
                                        toolbar: {
                                          show: false,
                                        },
                                      },
                                      dataLabels: {
                                        enabled: true,
                                      },
                                      colors: ['#E62129', '#66DA26', '#546E7A', '#E91E63', '#FF9800'],
                                      xaxis: {
                                        type: 'category',
                                        categories: x_cat,
                                        labels: {
                                          show: true,
                                          hideOverlappingLabels: false,
                                        }
                                      },
                          }"
                    ></apexchart>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="card h-100">
              <div class="card-body mb-3 ">
                <h5 class="card-title mb-2">{{ $t('dashboard.classification.text') }}</h5>
                <div class="">
                  <apexchart
                    class="apex-charts"
                    height="350"
                    type="treemap"
                    :series="categoryOptions.series"
                    :options="{
                        legend: {
                          show: false
                        },
                        chart: {
                          type: 'treemap'
                        },
                        colors: this.badge_color,
                        plotOptions: {
                          treemap: {
                            distributed: true,
                            enableShades: false
                          }
                        }
                    }" 
                  ></apexchart>
                </div>

              </div>
            </div>
          </div>
        </div>
        <!-- end row -->
<!-- 
       <div class="row mb-4">
            <div class="col-lg-4">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title mb-4">Point of Interest Twitter</h5>
                  <div class="table-responsive mb-0">
                    <table class="table table-nowrap table-centered table-hover">
                      <tbody>
                        <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="https://pbs.twimg.com/profile_images/1193018050498330624/QLVWhWcF_normal.jpg" alt="twitter" class="rounded-circle">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">Veronica Koman 許愛茜 <span><i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"></i></span></router-link>
                            </h5>
                            <small>VeronicaKoman</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                         <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="https://pbs.twimg.com/profile_images/1193018050498330624/QLVWhWcF_normal.jpg" alt="twitter" class="rounded-circle">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">Veronica Koman 許愛茜</router-link>
                            </h5>
                            <small>VeronicaKoman</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                         <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="https://pbs.twimg.com/profile_images/1193018050498330624/QLVWhWcF_normal.jpg" alt="twitter" class="rounded-circle">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">Veronica Koman 許愛茜</router-link>
                            </h5>
                            <small>VeronicaKoman</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                         <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="https://pbs.twimg.com/profile_images/1193018050498330624/QLVWhWcF_normal.jpg" alt="twitter" class="rounded-circle">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">Veronica Koman 許愛茜</router-link>
                            </h5>
                            <small>VeronicaKoman</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                         <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="https://pbs.twimg.com/profile_images/1193018050498330624/QLVWhWcF_normal.jpg" alt="twitter" class="rounded-circle">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">Veronica Koman 許愛茜 </router-link>
                            </h5>
                            <small>VeronicaKoman</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                     
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title mb-4">Point of Interest Instagram</h5>
                  <div class="table-responsive mb-0">
                    <table class="table table-nowrap table-centered table-hover">
                      <tbody>
                        <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="https://36627.selcdn.ru/jagajam-c90/INST:17841402212249084?time=1671006124" alt="twitter" class="rounded-circle" width="100%">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">HAPPY ASMARA <span><i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"></i></span></router-link>
                            </h5>
                            <small>@happy_asmara77</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                         <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="https://36627.selcdn.ru/jagajam-c90/INST:17841402020240655?time=1670056611" alt="twitter" class="rounded-circle" width="100%">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">difarinaindra</router-link>
                            </h5>
                            <small>@difarina_reall</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                         <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="http://localhost:8000/stream-img/?name=xyber_ID&path=media/telegram/xyber_ID" alt="twitter" class="rounded-circle" width="100%">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">Komunitas Cyber Security</router-link>
                            </h5>
                            <small>@xyberid</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                         <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="https://36627.selcdn.ru/jagajam-c90/INST:17841401757934375" alt="twitter" class="rounded-circle" width="100%">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">PSSI</router-link>
                            </h5>
                            <small>pssi</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                         <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="https://36627.selcdn.ru/jagajam-c90/INST:17841405532800351?time=1676541174" alt="twitter" class="rounded-circle" width="100%">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">Ade Armando </router-link>
                            </h5>
                            <small>@adearmando_official</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                     
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title mb-4">Point of Interest Group Telegram</h5>
                  <div class="table-responsive mb-0">
                    <table class="table table-nowrap table-centered table-hover">
                      <tbody>
                        <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="http://localhost:8000/stream-img/?name=xyber_ID&path=media/telegram/xyber_ID" alt="twitter" class="rounded-circle" width="100%">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">XyberID</router-link>
                            </h5>
                            <small>@xyber_ID</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                         <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="http://localhost:8000/stream-img/?name=OSINT_Indonesia&path=media/telegram/OSINT_Indonesia" alt="twitter" class="rounded-circle" width="100%">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">OSINT Indonesia</router-link>
                            </h5>
                            <small>@OSINT_Indonesia</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="http://localhost:8000/stream-img/?name=linuxhackingid&path=media/telegram/linuxhackingid" alt="twitter" class="rounded-circle" width="100%">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">Linuxhackingid</router-link>
                            </h5>
                            <small>@linuxhackingid</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="http://localhost:8000/stream-img/?name=flutter_id&path=media/telegram/flutter_id" alt="twitter" class="rounded-circle" width="100%">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">Flutter Indonesia</router-link>
                            </h5>
                            <small>@flutter_id</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 45px;">
                            <div class="avatar-sm">
                              <span
                                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-24"
                              >
                                 <img src="http://localhost:8000/stream-img/?name=cyberarmyidc&path=media/telegram/cyberarmyidc" alt="twitter" class="rounded-circle" width="100%">
                              </span>
                            </div>
                          </td>
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <router-link to="/" class="text-primary">CyberArmyID Community</router-link>
                            </h5>
                            <small>@cyberarmyidc</small>
                          </td>
                          <td>
                            <div class="text-center">
                              <router-link to="/" class="text-dark">
                                <i class="bx bx-pin h3 m-0"></i>
                              </router-link>
                            </div>
                          </td>
                        </tr>
                     
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
       </div> -->
       <Pin />
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Sellingchart from "./sellingchart";
import StatisticService from "@/helpers/statistic.service";
import PreferenceService from "@/helpers/preference.service.js";
import UserService from "@/helpers/user.service";
import simplebar from "simplebar-vue";
import { required } from "vuelidate/lib/validators";
import { earningLineChart, ChatData } from "./data";
import Pin from "./pin";
import moment from 'moment';
/**
 * Saas Dashboard Component
 */
export default {
  page: {
    title: "Osint Dashboard",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { simplebar, Layout, PageHeader, Sellingchart, Pin },
  data() {
    let categoryOptions = {
    series: [
      {
        data: [],
      },
    ]
  }

    let splineAreaChart = {
        series: [{
            name: 'Target',
            data: []
        }],
    };

    return {
      earningLineChart: earningLineChart,  
      splineAreaChart,
      // data
      badge_color:[],
      categoryOptions,
      ChatData: ChatData,
      total_citizen:'',
      total_tokopedia:'',
      total_facebook:'',
      total_tokopedia_date:'',
      total_facebook_date:'',
      elastic:"",
      x_cat: [],
      total_users:'',
      total_target:'',
      total_twitter:'',
      total_instagram:'',
      total_group_date:'',
      total_citizen_date:'',
      total_group:'',
      user_type:'',
      title: "Osint V.1",
      items: [
        {
          text: "Dashboard",
          active: true
        },
      ],
      submitted: false,
      chat: {
        message: ""
      }
    };
  },
  validations: {
    chat: {
      message: { required }
    }
  },
  methods: {
    getPreferences(){
        PreferenceService.getAllElastic()
        .then((response) => {
            this.elastic = response.data.data[0].ip_address;
            this.getCitizenDate();
            this.getCitizen();
            this.getTokped();
            this.getTokpedDate();
            this.getFacebook();
            this.getFacebookDate();
            this.getTele();
        })
        .catch((err) => {
            console.log(err);
        });
    },
    getCategory(){
        StatisticService.getTotalCategoryBy()
        .then(response => {
            response.data.data.forEach(event => {
              const data = {
                  x: event.category_name,
                  y: event.total_profile,
              }
              
           this.categoryOptions.series[0].data.push(data);
           this.badge_color.push(this.setColor(event.badge_color));
            // this.categoryOptions.chartOptions.colors.push(this.setColor(event.badge_color))
            // this.categoryOptions.chartOptions.labels.push(event.category_name)
            // this.categoryOptions.series.push(event.total_profile)
        });

        })
        .catch(err => {
            console.log(err);
        });
    },
    list() {
      UserService.getProfile()
      .then(response => {
        this.user_type = response.data.data.user_type
      })
      .catch(e => {
        this.message = e.response.data.data
      });
    },
    setColor(color){
      let clr = '';
      switch (color) {
            case "red":
              clr = this.theme == 'dark' ? "#991b1b" : "#EF4444" 
              break;
            case "blue":
              clr = this.theme == 'dark' ? "#1e40af" : "#60A5FA"
              break;
            case "green":
              clr = this.theme == 'dark' ? "#065f46" : "#34D399" 
              break;
              case "yellow":
              clr = this.theme == 'dark' ? "#a18401" : "#EAB308" 
              break;
            case "purple":
              clr = this.theme == 'dark' ? "#5b21b6" : "#818CF8" 
              break;
            case "pink":
              clr = this.theme == 'dark' ? "#9d174d" : "#EC4899" 
              break;
              case "teal":
              clr = this.theme == 'dark' ? "#147066" : "#14B8A6" 
              break;
              case "orange":
              clr = this.theme == 'dark' ? "#af4b04" : "#F97316" 
              break;
            case "rose":
              clr = this.theme == 'dark' ? "#c41432" : "#F43F5E" 
              break;
            case "sky":
              clr = this.theme == 'dark' ? "#0b6d99" : "#38BDF8" 
              break;
            case "violet":
              clr = this.theme == 'dark' ? "#4509ad" : "#7C3AED" 
              break;
              case "indigo":
              clr = this.theme == 'dark' ? "#3730a3" : "#6366F1" 
              break;
            case "lime":
              clr = this.theme == 'dark' ? "#60960c" : "#84CC16" 
              break;
            case "cyan":
              clr = this.theme == 'dark' ? "#04788c" : "#06B6D4" 
              break;
            case "gray":
              clr = this.theme == 'dark' ? "#1f2937" : "#71717A" 
              break;
            default:
              clr = this.theme == 'dark' ? "#3397c4" : "#38BDF8" 
              break;
      }
      return clr;
    },
    getUser(){
        StatisticService.getTotalUser()
        .then(response => {
            this.total_users = response.data.data;
        })
        .catch(err => {
            console.log(err);
        });
    },
    getIG(){
        StatisticService.getTotalInstagram()
        .then(response => {
            this.total_instagram = response.data.data;
        })
        .catch(err => {
            console.log(err);
        });
    },
    getTwit(){
        StatisticService.getTotalTwitter()
        .then(response => {
            this.total_twitter = response.data.data;
        })
        .catch(err => {
            console.log(err);
        });
    },
    getCitizen(){
      var data = {  
            "size": 10
            }
      StatisticService.getTotalCitizen(this.elastic, data)
      .then(response => {
          this.total_citizen =  response.data.hits.total.value
      })
      .catch(err => {
          console.log(err);
      });
    },
    getCitizenDate(){
      var data = {  
            "size": 1
            }
      StatisticService.getTotalCitizenDate(this.elastic, data)
      .then(response => {
          this.total_citizen_date =  response.data.hits.hits[0]._source['@timestamp'];
      })
      .catch(err => {
          console.log(err);
      });
    },

    getTele(){
      var data = {  
            "size": 10
            }
      StatisticService.getTotalGroupTele(this.elastic, data)
      .then(response => {
             this.total_group = response.data.hits.hits[0]._source.listgroup.length;  
             this.total_group_date = response.data.hits.hits[0]._source.created_at;
            //  console.log('total_group', response.data.hits.hits[0]._source.created_at);
      })
      .catch(err => {
          console.log(err);
      });
    },
    getTokped(){
      var data = {  
            "size": 10
            }
      StatisticService.getTotalTokopedia(this.elastic, data)
      .then(response => {
          this.total_tokopedia = response.data.hits.total.value
      })
      .catch(err => {
          console.log(err);
      });
    },
    getTokpedDate(){
      var data = {  
            "size": 1
            }
      StatisticService.getTotalTokopedia(this.elastic, data)
      .then(response => {
          this.total_tokopedia_date = response.data.hits.hits[0]._source['@timestamp'];
      })
      .catch(err => {
          console.log(err);
      });
    },
    getFacebook(){
      var data = {  
            "size": 10
            }
      StatisticService.getTotalFacebook(this.elastic, data)
      .then(response => {
          this.total_facebook =  response.data.hits.total.value
      })
      .catch(err => {
          console.log(err);
      });
    },
    getFacebookDate(){
      var data = {  
            "size": 1
            }
      StatisticService.getTotalFacebookdate(this.elastic, data)
      .then(response => {
          this.total_facebook_date = response.data.hits.hits[0]._source['@timestamp'];
      })
      .catch(err => {
          console.log(err);
      });
    },
    getTarget(){
        StatisticService.getTotalTargetBy()
        .then(response => {
            this.total_target = response.data.data
        })
        .catch(err => {
            console.log(err);
        });
    },
    formSubmit(e) {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        const id = this.ChatData.length;
        const message = this.chat.message;
        const currentDate = new Date();
        this.ChatData.push({
          id: id + 1,
          align: "right",
          name: "Henry Wells",
          message,
          time: currentDate.getHours() + ":" + currentDate.getMinutes()
        });
      }
      this.submitted = false;
      this.chat = {};
    },
    dailyReport(){
      StatisticService.getDailyTargetBy()
      .then(response => {
            var asc = response.data.data;
            const sortedArray  = asc.sort((a,b) => new moment(a.date).format('YYYYMMDDhhmmss') - new moment(b.date).format('YYYYMMDDhhmmss'));
            var datasorting = sortedArray;

          datasorting.forEach(event => {
          this.x_cat.push(event.label)
          this.splineAreaChart.series[0].data.push(event.total_daily_target)
        })
      })
      .catch(e => {
        console.log(e.response.data.data)
      })
    },
    formatPrice(value) {
        return value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\.")
    },
    formatDate(value){
        return moment(value).format("DD-MM-YYYY");
    },
  },
   beforeMount() {
    this.getPreferences();
    this.list();
    this.getCategory();
    this.getTarget();
    this.getUser();
    this.getIG();
    this.getTwit();
  },
  mounted(){
    this.dailyReport();
  }
};
</script>